export default "__VITE_ASSET__DboDNa2w__"